/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

export enum HttpStatusCode {
  // success
  SUCCESS = 200,
  // created
  CREATED = 201,
  // accepted
  ACCEPTED = 202,
  // no content
  NO_CONTENT = 204,
  // invalid request
  BAD_REQUEST = 400,
  // unauthorized
  UNAUTHORIZED = 401,
  // forbidden
  FORBIDDEN = 403,
  // not found
  NOT_FOUND = 404,
  // request timeout
  REQUEST_TIMEOUT = 408,
  // server error
  INTERNAL_SERVER_ERROR = 500,
  // service unavailable
  SERVICE_UNAVAILABLE = 503,
  // gateway timeout
  GATEWAY_TIMEOUT = 504,
}
